import $ from 'jquery';
import constants from 'Constants.js';
import Immutable from 'immutable';

import { View } from 'backbone';

import alignmentTemplate from 'properties/main/text-alignment.ejs';


class MainTextAlignmentView extends View {



    initialize( opts ) {
        this.options = opts || {};
        this.template = alignmentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.selectedColor = 'lightgrey';
        this.unselectedColor = 'transparent';

        this.events = {
            'click img' : 'updateAttributes'
        };

        this.model.set('alignLeftSelection', this.unselectedColor, {silent:true});
        this.model.set('alignCenterSelection', this.unselectedColor, {silent:true});
        this.model.set('alignRightSelection', this.unselectedColor, {silent:true});

        // Add needed property
        if (!this.model.get('align')) {
            this.model.set('align', 'left', {silent:true});
            this.model.set('alignLeftSelection', this.selectedColor, {silent:true});
        }

      switch  (this.model.get('align')) {
        case 'left':
          this.model.set('alignLeftSelection', this.selectedColor, {silent:true});
          break;
        case 'center':
          this.model.set('alignCenterSelection', this.selectedColor, {silent:true});
          break;
        case 'right':
          this.model.set('alignRightSelection', this.selectedColor, {silent:true});
          break;
      }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        //const propVal  = ev.currentTarget.value;
        var newValue = "left";
        this.model.set('alignLeftSelection', this.unselectedColor, {silent:true});
        this.model.set('alignCenterSelection', this.unselectedColor, {silent:true});
        this.model.set('alignRightSelection', this.unselectedColor, {silent:true});
        if (propName === "align-center") {
            newValue = "center";
            this.model.set('alignCenterSelection', this.selectedColor, {silent:true});
        } else if (propName === "align-right") {
            newValue = "right";
            this.model.set('alignRightSelection', this.selectedColor, {silent:true});
        }
        else {
            this.model.set('alignLeftSelection', this.selectedColor, {silent:true});
        }
        this.model.set( 'align', newValue );
    }


    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        this.delegateEvents();
        return this;
    }

}

export default MainTextAlignmentView;
